<template>
  <div class="mb-10">
    <AppOnOffToggle v-model="value">
      {{ label }}
    </AppOnOffToggle>
  </div>
</template>

<script>
export default {
  name: 'ReportUpdateSearchFilterToggle',
  props: {
    queryProperty: { type: String, required: true },
    label: { type: String, required: true },
    on: { type: Boolean, required: true },
  },
  computed: {
    value: {
      get() {
        return this.on;
      },
      set(newValue) {
        this.$store.dispatch('updateSearch', { [this.queryProperty]: !!newValue });
      },
    },
  },
};
</script>
